import { useState } from 'react';
import { createConsent } from '../../../../../../api/consent';
import { CONSENT_INTRO, COMMON_SECTIONS, SELF_CONSENT_NOTICE } from '../consentText/consentContent';
import styles from './SelfConsentFormStep.module.css';

function SelfConsentFormStep({ seniorInfo, seniorId, onDone }) {
  const [agreed, setAgreed] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [errorMsg, setErrorMsg] = useState('');

  const handleSubmit = async () => {
    if (agreed !== 'agree') {
      setErrorMsg('동의를 선택해 주세요.');
      return;
    }
    setIsLoading(true);
    setErrorMsg('');
    try {
      await createConsent({ senior: seniorInfo, consentType: 'SELF' });
      onDone();
    } catch (err) {
      setErrorMsg(err.message || '오류가 발생했습니다. 다시 시도해 주세요.');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className={styles.wrap}>
      <p className={styles.pageTitle}>개인정보수집 및 이용동의(필수)</p>
      <p className={styles.intro}>{CONSENT_INTRO}</p>

      {COMMON_SECTIONS.map((sec) => (
        <div key={sec.title} className={styles.section}>
          <p className={styles.sectionTitle}>{sec.title}</p>
          <table className={styles.table}>
            <tbody>
              {sec.rows.map((row) => (
                <tr key={row.label}>
                  <th>{row.label}</th>
                  <td>{row.value}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      ))}

      <p className={styles.notice}>{SELF_CONSENT_NOTICE}</p>

      <hr className={styles.divider} />

      <div className={styles.agreeRow}>
        <label className={styles.radioLabel}>
          <input
            type="radio"
            name="consent"
            value="agree"
            checked={agreed === 'agree'}
            onChange={() => { setAgreed('agree'); setErrorMsg(''); }}
          />
          동의
        </label>
        <label className={styles.radioLabel}>
          <input
            type="radio"
            name="consent"
            value="disagree"
            checked={agreed === 'disagree'}
            onChange={() => setAgreed('disagree')}
          />
          미동의
        </label>
      </div>

      {errorMsg && <p className={styles.errorMsg}>{errorMsg}</p>}

      <button className={styles.submitBtn} onClick={handleSubmit} disabled={isLoading || agreed !== 'agree'}>
        {isLoading ? '처리 중...' : '제출'}
      </button>
    </div>
  );
}

export default SelfConsentFormStep;
